// Bundler-agnostic default-export resolution for CommonJS packages (Babel
// output with a defineProperty'd __esModule flag). Rollup/Vite 4 unwrapped
// their `.default` automatically; Rolldown/Vite 8 hands back the module
// object, so `import X from "pkg"` yields the namespace and method calls
// explode at runtime. Import these re-exports instead of the raw packages.
import * as IntercomModule from "@intercom/messenger-js-sdk"

const resolveDefault = (mod: any) => mod.default?.default ?? mod.default ?? mod

const Intercom = resolveDefault(IntercomModule) as typeof IntercomModule.default

// Named exports pass through unchanged — only `default` needs unwrapping
export const { boot, shutdown } = IntercomModule
export { Intercom }

import * as VapiModule from "@vapi-ai/web"
export const Vapi = resolveDefault(VapiModule) as typeof VapiModule.default

import * as UseLocalStorageModule from "use-local-storage"
export const useLocalStorage = resolveDefault(
  UseLocalStorageModule,
) as typeof UseLocalStorageModule.default

import * as TwemojiModule from "react-twemoji"
export const Twemoji = resolveDefault(
  TwemojiModule,
) as typeof TwemojiModule.default

import * as MarqueeModule from "react-fast-marquee"
export const Marquee = resolveDefault(
  MarqueeModule,
) as typeof MarqueeModule.default

// Vapi >=2.5.2 wraps Daily-originated errors as
// { type: "daily-error", error: <serialized daily event>, timestamp } where
// older SDKs passed the daily event through raw. Normalise both shapes so
// error handlers can keep branching on the daily error's type/msg.
export const normalizeVapiError = (event: any) => {
  // Production `daily-error` payloads carry the daily event's real fields one
  // level deeper than the old guess: { error: { action, errorMsg, message } }
  // where `message` is either the daily error object ({ msg, type }) or a
  // plain string. ENG-1551: missing this shape left type/msg undefined, so
  // normal "ejected"/"room was deleted" teardown fell into the generic error
  // branch and every clean call end flashed a destructive toast.
  const daily = event?.type === "daily-error" ? event.error : undefined
  const inner =
    daily?.error ??
    (typeof daily?.message === "object" ? daily.message : undefined) ??
    event?.error
  const msg =
    (typeof inner?.msg === "string" ? inner.msg : undefined) ??
    // String-message daily errors (e.g. "room lookup timed out") only name
    // the failure in errorMsg
    (typeof daily?.errorMsg === "string" ? daily.errorMsg : undefined)
  return {
    type: inner?.type as string | undefined,
    msg,
    // Where the failure originated — "daily" is WebRTC/network
    // infrastructure, "vapi" is the platform itself. Tagged onto Sentry
    // errors so call failures can be split by source.
    source: event?.type === "daily-error" ? "daily" : "vapi",
  }
}
